<div class="app-layout">
  <idap-top-navigation />
  <idap-dashboard-layout>
    <router-outlet />
  </idap-dashboard-layout>
  <idap-footer />
</div>
